exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* .msg-image__horizontal{\n  max-width: 250px;\n  aspect-ratio: 16/9;\n}\n.msg-image__horizontal.large-image{\n  max-width: 380px;\n}\n.msg-image__vertical{\n  max-height: 270px;\n  aspect-ratio: 4/5;\n}\n.msg-image__vertical.large-image{\n  max-height: 400px;\n} */\n.msg-image__main img{\n  border-radius: 5px;\n  /* margin-bottom: 3px; */\n}\n.msg-image__main{\n  position: relative;\n  /* box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1); */\n  /* min-height: 140px;\n  min-width: 120px; */\n  text-align: center;\n  background-color: #fff;\n  border-radius: 14px;\n  padding: 20px;\n}\n.msg-image__img{\n  /* max-width: 23vw; */\n  max-width: 100%;\n  max-height: 136px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Message Components/Image.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Message Components/Image.css
// module chunks = 120